import { ReactElement } from 'react';
import Carousel from 'components/UI/Carousel';
import { IPageDoctorFields } from 'types/contentful';
import Link from 'components/UI/Link';
import { doctorDisplayName } from 'lib/util';

interface DoctorCarouselProps {
  doctors: IPageDoctorFields[];
  title: string;
  titleElement?: ReactElement;
}

export default function DoctorCarousel({
  title,
  doctors,
  titleElement,
}: DoctorCarouselProps): ReactElement {
  const aspectRatio = 'portrait';

  const carouselItems = doctors?.map((doctor, index) => {
    return (
      <div className="text-left max-w-xs mx-auto md:max-w-full" key={index}>
        {doctor.doctorPhoto && (
          <div
            style={{ backgroundImage: `url('${doctor.doctorPhoto.fields.file.url}')`, aspectRatio }}
            className={`aspect-ratio-${aspectRatio} bg-cover bg-center mb-4`}
          ></div>
        )}

        <div className="font-semibold">{doctorDisplayName(doctor)}</div>

        {doctor.slug && (
          <Link slug={`/doctors/${doctor.slug}`}>
            <a className="inline-flex items-center gap-2 text-tertiary-actual">
              <span>Learn More</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="6"
                height="12"
                viewBox="0 0 9 15"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M1.33301 1.33301L7.33301 7.33301L1.33301 13.333"
                  stroke="currentColor"
                  strokeWidth="2.66667"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </Link>
        )}
      </div>
    );
  });

  return (
    <Carousel
      title={title}
      items={carouselItems ?? []}
      titleElement={titleElement}
      className="doctor-carousel pb-10 md:pb-20 px-site-component"
      slidesToShow={5}
      tabletSlidesToShow={3}
      mobileSlidesToShow={1}
      contentClassName="w-full mx-0"
      sliderClassName=""
    />
  );
}
